export default __webpack_public_path__ + "static/card-img06-b9ca37eff3f9c3f047eb865ccc2ee873.jpg";